import KioskAutoScroll from './KioskAutoScroll.jsx';

export default KioskAutoScroll;


// WEBPACK FOOTER //
// ./src/components/KioskAutoScroll/index.jsx